import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import PageHeader from '../../../../components/PageHeader';
import Button from '../../../../components/Button';
import { AppContext, useApp } from '../../../../contexts/AppContext';
import { useSharkPlugins } from '../../../../contexts/SharkPluginsProvider';
import { useHistory } from 'react-router-dom';

const Header = ({
    title,
    icon,
    onClick
}) => {
    const { t } = useContext(AppContext)
    const history = useHistory();

    const renderOptions = () => (
        <div className="ml3 flex">
            <Button
                text={"Abrir chamado"}
                icon="plus"
                variant="ghost"
                onClick={() => {
                    history.push("/tickets/new")
                }}
            />
        </div>
    );

    return (
        <PageHeader
            title={title}
            icon={icon}
            relatedOptions={renderOptions()}
        />
    );
};

Header.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.string,
    onClick: PropTypes.func
};

export default Header;
